import { pipe } from '@helo/utils'
import { StateCreator } from 'zustand'

import { PersistenceSliceActions } from './persistenceSlice.actions'
import { PersistedItem } from './persistenceSlice.types'

export type PersistenceState = {
  initialized: boolean
  items: PersistedItem[]
  localstoragePersistenceKey: string
  persist: (item: PersistedItem) => void
  loadPersistedItems: () => void
  handleEvent: (event: PersistedItem['until']) => void
  clearPersistedItems: () => void
  getItem: (key: string) => PersistedItem | undefined
  getItemValue: <T = any>(key: string) => T | undefined
  // setItem: (key: string, value: any) => void
  // registerItems: (items: PersistedItem[]) => void
}

export const LOCALSTORAGE_PERSISTENCE_PREFIX = 'helo-persistence:'

export type PersistenceSlice = {
  persistence: PersistenceState
}

export const persistenceSlice: StateCreator<
  PersistenceSlice,
  [],
  [],
  PersistenceSlice
> = (set, get) => ({
  persistence: {
    initialized: false,
    items: [],
    localstoragePersistenceKey: LOCALSTORAGE_PERSISTENCE_PREFIX,
    persist: (item: PersistedItem) => {
      pipe(get(), PersistenceSliceActions.persistItem(item), set)
    },

    loadPersistedItems: () => {
      pipe(get(), PersistenceSliceActions.loadPersistedItems(), set)
    },

    handleEvent: (event: PersistedItem['until']) => {
      pipe(get(), PersistenceSliceActions.triggerPersistenceEvent(event), set)
    },

    clearPersistedItems: () => {
      pipe(
        get(),
        store => ({
          ...store,
          persistence: {
            ...store.persistence,
            items: [],
          },
        }),
        PersistenceSliceActions.persistItems,
        set,
      )
    },

    getItem: (key: string) =>
      pipe(get(), PersistenceSliceActions.getPersistenceItem(key)),

    getItemValue: <T>(key: string): T =>
      PersistenceSliceActions.getPersistenceItemValue<T>(key)(get()) as T,
    // setItem: (key: string, value: any) =T > {
    //   pipe(get(), setPersistedItem({}), persistItem({}), set)
    // },
  },
})

export { PersistenceSliceActions }
